'use client'

import { useProduct } from '@/screens/Product/hooks/useProduct'

import { unEscape } from '@/shared/lib/utils/string/un-escape'
import { OrderType } from '@/shared/types/product-types'
import { Col, Row } from '@/shared/ui/Grid'

import cl from '../../ui/product-main/product-page-main.module.scss'
import panelCl from '../../ui/product-main/product-panel/product-panel.module.scss'

import { DiscountProductAvailabilityWidget } from './discount-product-availability-widget'
import { DiscountProductFixedPanel } from './discount-product-fixed-panel'
import { DiscountProductParameters } from './discount-product-parameters'
import { DiscountProductPaymentWidgets } from './discount-product-payment-widgets'
import { DiscountProductPricePanel } from './discount-product-price-panel'
import { DiscountProductSlider } from './discount-product-slider'

export const DiscountProductMain = (): JSX.Element => {
	const { product } = useProduct()
	const isArchive = product.ORDER_TYPE === OrderType.Archive || product.ORDER_TYPE === OrderType.HideBuy

	return (
		<section className={cl.productMain}>
			<Row gutter={{ xs: 24, sm: 24, md: 24, lg: 24 }}>
				<Col xs={24} lg={11}>
					<DiscountProductSlider />
					<p className={cl.productMainMobileTitle}>{unEscape(product.TITLE)}</p>
				</Col>

				<Col lg={13} xs={24}>
					<section id="productPanel" className={panelCl.productPanel}>
						<Row gutter={[24, 40]}>
							<Col xs={24} lg={12}>
								<DiscountProductParameters />
							</Col>
							<Col xs={24} lg={12}>
								{!isArchive ? (
									<>
										<DiscountProductPricePanel />
										<DiscountProductPaymentWidgets />
										<DiscountProductAvailabilityWidget />
									</>
								) : (
									<div className={panelCl.emptyButton} />
								)}
							</Col>
						</Row>
						<DiscountProductFixedPanel />
					</section>
				</Col>
			</Row>
		</section>
	)
}
